import ConstantApi from '../../../../ConstantApi';
import axiosCall from '../../../axiosCall';
import { fetchPartyDetailsData } from '../../../partyDetails/partyDetails.action';
import { fetchCommonPropertyById } from '../../../property/common/commonProperty.actions';
import { fetchSeasonMaster } from '../../../seasonMaster/seasonMaster.actions';
import { fetchSizeInfoData } from '../../../sizeInfo/sizeInfo.actions';
import { fetchUnitMaster } from '../../../unitMaster/unitMaster.actions';
import { fetchYarnPOProgramDropdown, fetchYarnPOSalesOrderDropdown, fetchYarnPOSupplierDropdown } from '../../YarnPO/yarnPO/yarnPO.actions';
import {
    CREATE_ALL_OVER_PRINTING_DC_FAILURE,
    CREATE_ALL_OVER_PRINTING_DC_REQUEST,
    CREATE_ALL_OVER_PRINTING_DC_SUCCESS,
    CREATE_USER_FORM_ALL_OVER_PRINTING_DC,
    DELETE_ALL_OVER_PRINTING_DC_FAILURE,
    DELETE_ALL_OVER_PRINTING_DC_REQUEST,
    DELETE_ALL_OVER_PRINTING_DC_SUCCESS,
    FETCH_SINGLE_ALL_OVER_PRINTING_DC_FAILURE,
    FETCH_SINGLE_ALL_OVER_PRINTING_DC_REQUEST,
    FETCH_SINGLE_ALL_OVER_PRINTING_DC_SUCCESS,
    FETCH_ALL_OVER_PRINTING_DC_FAILURE,
    FETCH_ALL_OVER_PRINTING_DC_REQUEST,
    FETCH_ALL_OVER_PRINTING_DC_SUCCESS,
    ALL_OVER_PRINTING_DC_USERFORM_RESET,
    UPDATE_ALL_OVER_PRINTING_DC_FAILURE,
    UPDATE_ALL_OVER_PRINTING_DC_REQUEST,
    UPDATE_ALL_OVER_PRINTING_DC_SUCCESS,
    ALL_OVER_PRINTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB,
    FETCH_ALL_OVER_PRINTING_DC_STYLE_REQUEST,
    FETCH_ALL_OVER_PRINTING_DC_STYLE_SUCCESS,
    FETCH_ALL_OVER_PRINTING_DC_STYLE_FAILURE,
    FETCH_ALL_OVER_PRINTING_DC_INVOICE_REQUEST,
    FETCH_ALL_OVER_PRINTING_DC_INVOICE_SUCCESS,
    FETCH_ALL_OVER_PRINTING_DC_INVOICE_FAILURE,
    CHECK_ALL_UPDATE_REQUEST_ALL_OVER_PRINTING,
    CHECK_ALL_UPDATE_SUCCESS_COMPACTING_ALL_OVER_PRINTING,
    CHECK_ALL_UPDATE_FALIURE_COMPACTING_ALL_OVER_PRINTING,
    CLOSE_BTN_POST_REQUEST_ALL_OVER_PRINTING,
    CLOSE_BTN_POST_SUCCESS_COMPACTING_ALL_OVER_PRINTING,
    CLOSE_BTN_POST_FALIURE_COMPACTING_ALL_OVER_PRINTING
} from './printingDC.actionsType';

// FETCH PROPERTY MASTER
export let fetchPrintingDC = (startDate, endDate, unitId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.printingDCMasterGET}?FldFromDate=${startDate}&FldToDate=${endDate}&FldFKUnitId=${-1}`,
        responseTypeRequest: FETCH_ALL_OVER_PRINTING_DC_REQUEST,
        responseTypeSuccess: FETCH_ALL_OVER_PRINTING_DC_SUCCESS,
        responseTypeFailure: FETCH_ALL_OVER_PRINTING_DC_FAILURE
    };
    return axiosCall(config);
};

// create user Form
export let createPrintingDCUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_ALL_OVER_PRINTING_DC, payload: { key, value } });
    };
};

// CREATE PROPERTY MASTER
export let createPrintingDCMaster = (formData, modalClose, startDate, endDate, unitId, isDetail) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: 0,
        ...formData,
        fldFKStyle: parseInt(formData.fldFKStyle),
        fldFKSupplierID: parseInt(formData.fldFKSupplierID),
        fldFKTypeofPO: parseInt(formData.fldFKTypeofPO),
        fldFKSource: parseInt(formData.fldFKSource),
        fldFKSeason: parseInt(formData.fldFKSeason),
        fldFKDepartment: parseInt(formData.fldFKDepartment),
        fldDCNo: 'Auto Generated',
        fldDCDate: today.toISOString(),
        fldDeliveryStartDate: formData?.fldDeliveryStartDate ? formData.fldDeliveryStartDate : today.toISOString(),
        fldDeliveryEndDate: formData?.fldDeliveryEndDate ? formData.fldDeliveryEndDate : today.toISOString(),
        fldIsInHouseProduction: formData?.fldIsInHouseProduction,
        fldIsInHouseDelivery: formData.fldIsInHouseDelivery,
        // fldFKDeliveryAt: formData.fldIsInHouseDelivery ? 0 : parseInt(formData.fldFKDeliveryAt),
        fldFKDeliveryAt: parseInt(formData.fldFKDeliveryAt),
        fldIsReprocess: formData.fldIsReprocess,
        fldIsWithCost: formData.fldIsReprocess === false ? true : formData.fldIsWithCost,
        fldNoofBags: Number(formData.fldNoofBags),
        fldTotalQty: Number(formData.fldTotalQty),
        fldInwardQty: 0,
        fldCancelQty: 0,
        fldBalanceQty: 0,
        fldPreparedBy: 'dummy',
        fldPrepareDate: today.toISOString(),
        fldVerifyBy: 'dummy',
        fldVerifyDate: today.toISOString(),
        fldAuthorizeBy: 'dummy',
        fldAuthorizeDate: today.toISOString(),
        fldInwardBy: 'dummy',
        fldInwardDate: today.toISOString(),
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: 11,
        fldCreatedDt: today.toISOString(),
        fldFKStatus: formData.fldFKStatus,
        fldFKUnitId: parseInt(formData.fldFKUnitId),
        fldFKSection: parseInt(formData.fldFKSection),
        fldFKProgram: parseInt(formData.fldFKProgram),
        fldApprovalStatus: 0,
        fldUnitCode: '',
        fldUnitName: '',
        fldUnitAddress1: '',
        fldUnitAddress2: '',
        fldUnitFKArea: 0,
        fldUnitCountry: '',
        fldUnitState: '',
        fldUnitCity: '',
        fldUnitArea: '',
        fldUnitPincode: '',
        fldUnitGSTNo: '',
        fldSupplierCode: '',
        fldSupplierName: 'dummy',
        fldSupplierAddress1: '',
        fldSupplierAddress2: '',
        fldSupplierFKArea: 0,
        fldSupplierCountry: '',
        fldSupplierState: '',
        fldSupplierCity: '',
        fldSupplierArea: '',
        fldSupplierPincode: '',
        fldSupplierGSTNo: '',
        fldDeliveryAtCode: '',
        fldDeliveryAtName: '',
        fldDeliveryAtAddress1: '',
        fldDeliveryAtAddress2: '',
        fldDeliveryAtFKArea: 0,
        fldDeliveryAtCountry: '',
        fldDeliveryAtState: '',
        fldDeliveryAtCity: '',
        fldDeliveryAtArea: '',
        fldDeliveryAtPincode: '',
        fldDeliveryAtGSTNo: '',
        fldItemsGrossValue: formData.fldItemsGrossValue ? Number(formData.fldItemsGrossValue) : 0,
        fldItemsTaxableValue: formData.fldItemsTaxableValue ? Number(formData.fldItemsTaxableValue) : 0,
        fldItemsGSTValue: formData.fldItemsGSTValue ? Number(formData.fldItemsGSTValue) : 0,
        fldItemsTotalValue: formData.fldItemsTotalValue ? Number(formData.fldItemsTotalValue) : 0,
        fldDiscountPercentage: formData.fldDiscountPercentage ? Number(formData.fldDiscountPercentage) : 0,
        fldDiscountValue: formData.fldDiscountValue ? Number(formData.fldDiscountValue) : 0,
        fldGrandGrossValue: formData.fldGrandGrossValue ? Number(formData.fldGrandGrossValue) : 0,
        fldOtherPlusValue: formData.fldOtherPlusValue ? Number(formData.fldOtherPlusValue) : 0,
        fldOtherMinusValue: formData.fldOtherMinusValue ? Number(formData.fldOtherMinusValue) : 0,
        fldRoundoff: formData.fldRoundoff ? Number(formData.fldRoundoff) : 0,
        fldGrandTotalValue: formData.fldGrandTotalValue ? Number(formData.fldGrandTotalValue) : 0,
        fldFKPaymentTerms: parseInt(formData.fldFKPaymentTerms),

        // fldFKSizeInfo: parseInt(formData.fldFKSizeInfo)
    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.printingDCMasterPOST}`,
        responseTypeRequest: CREATE_ALL_OVER_PRINTING_DC_REQUEST,
        responseTypeSuccess: CREATE_ALL_OVER_PRINTING_DC_SUCCESS,
        responseTypeFailure: CREATE_ALL_OVER_PRINTING_DC_FAILURE,
        resetFormData: isDetail ? ALL_OVER_PRINTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB : ALL_OVER_PRINTING_DC_USERFORM_RESET,
        modalClose,
        PoDcInwardNo: 'fldPONO',
        PoDcInwardType: 'DC',
        isPopupOpen: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchPrintingDC(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

// GET SINGLE PROPERTY MASTER
export let getSinglePrintingDCMaster = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.printingDCMasterGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_ALL_OVER_PRINTING_DC_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_ALL_OVER_PRINTING_DC_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_ALL_OVER_PRINTING_DC_FAILURE,
        singlApiArray: [
            fetchSeasonMaster(),
            fetchYarnPOSupplierDropdown('TblPrintingDC'),
            fetchCommonPropertyById(52),
            fetchCommonPropertyById(46),
            fetchCommonPropertyById(28),
            fetchUnitMaster(),
            fetchYarnPOProgramDropdown('TblPrintingDC'),
            fetchYarnPOSalesOrderDropdown(),
            // fetchStyleMasterBasicData(),
            fetchSizeInfoData(),
            fetchPrintingDCStyleGetList()
        ]
    };
    return axiosCall(config);
};

export let getPrintingDCInvoiceData = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.printingDCInvoiceGET}/${id}`,
        responseTypeRequest: FETCH_ALL_OVER_PRINTING_DC_INVOICE_REQUEST,
        responseTypeSuccess: FETCH_ALL_OVER_PRINTING_DC_INVOICE_SUCCESS,
        responseTypeFailure: FETCH_ALL_OVER_PRINTING_DC_INVOICE_FAILURE
    };
    return axiosCall(config);
};

//UPDATE PROPERTY MASTER
export let updatePrintingDCMaster = (formData, id, startDate, endDate, unitId) => {
    console.log("formDatasss", formData);
    let today = new Date();
    let data = JSON.stringify({
        fldId: parseInt(id),
        fldFKSupplierID: parseInt(formData.fldFKSupplierID),
        fldFKTypeofPO: parseInt(formData.fldFKTypeofPO),
        fldFKSource: parseInt(formData.fldFKSource),
        fldFKSeason: parseInt(formData.fldFKSeason),
        fldFKSaleOrder: parseInt(formData.fldFKSaleOrder),
        fldFKDepartment: parseInt(formData.fldFKDepartment),
        fldFKStyle: parseInt(formData.fldFKStyle),
        fldDCNo: formData?.fldDCNo,
        fldDCDate: formData?.fldDCDate,
        fldDeliveryStartDate: formData.fldDeliveryStartDate,
        fldDeliveryEndDate: formData.fldDeliveryEndDate,
        fldIsInHouseProduction: formData?.fldIsInHouseProduction,
        fldIsInHouseDelivery: formData.fldIsInHouseDelivery,
        // fldFKDeliveryAt: formData.fldIsInHouseDelivery ? 0 : parseInt(formData.fldFKDeliveryAt),
        fldFKDeliveryAt: parseInt(formData.fldFKDeliveryAt),
        fldIsReprocess: formData.fldIsReprocess,
        fldIsWithCost: formData.fldIsReprocess === false ? true : formData.fldIsWithCost,
        fldNoofBags: Number(formData.fldNoofBags),
        fldTotalQty: Number(formData.fldTotalQty),
        fldInwardQty: formData?.fldInwardQty,
        fldCancelQty: formData?.fldCancelQty,
        fldBalanceQty: formData?.fldBalanceQty,

        fldVerifyBy: formData.fldVerifyBy,
        fldVerifyDate: formData.fldVerifyDate,
        fldAuthorizeBy: formData.fldAuthorizeBy,
        fldAuthorizeDate: formData.fldAuthorizeDate,

        fldInwardBy: '',
        fldInwardDate: today.toISOString(),
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: formData.fldCreatedBy,
        fldCreatedDt: formData.fldCreatedDt,
        fldPreparedBy: formData.fldPreparedBy,
        fldPrepareDate: formData.fldPrepareDate,
        fldIsAuthorized: formData.fldIsAuthorized,
        fldIsPrepared: formData.fldIsPrepared,
        fldIsVerified: formData.fldIsVerified,
        fldModifiedBy: 0,
        fldModifiedDt: today.toISOString(),
        fldFKStatus: formData.fldFKStatus,
        fldFKUnitId: parseInt(formData.fldFKUnitId),
        fldFKSection: parseInt(formData.fldFKSection),
        fldFKProgram: parseInt(formData.fldFKProgram),
        fldApprovalStatus: 0,
        fldUnitCode: '',
        fldUnitName: '',
        fldUnitAddress1: '',
        fldUnitAddress2: '',
        fldUnitFKArea: 0,
        fldUnitCountry: '',
        fldUnitState: '',
        fldUnitCity: '',
        fldUnitArea: '',
        fldUnitPincode: '',
        fldUnitGSTNo: '',
        fldSupplierCode: '',
        fldSupplierName: 'dummy',
        fldSupplierAddress1: '',
        fldSupplierAddress2: '',
        fldSupplierFKArea: 0,
        fldSupplierCountry: '',
        fldSupplierState: '',
        fldSupplierCity: '',
        fldSupplierArea: '',
        fldSupplierPincode: '',
        fldSupplierGSTNo: '',
        fldDeliveryAtCode: '',
        fldDeliveryAtName: '',
        fldDeliveryAtAddress1: '',
        fldDeliveryAtAddress2: '',
        fldDeliveryAtFKArea: 0,
        fldDeliveryAtCountry: '',
        fldDeliveryAtState: '',
        fldDeliveryAtCity: '',
        fldDeliveryAtArea: '',
        fldDeliveryAtPincode: '',
        fldDeliveryAtGSTNo: '',
        fldItemsGrossValue: formData.fldItemsGrossValue ? Number(formData.fldItemsGrossValue) : 0,
        fldItemsTaxableValue: formData.fldItemsTaxableValue ? Number(formData.fldItemsTaxableValue) : 0,
        fldItemsGSTValue: formData.fldItemsGSTValue ? Number(formData.fldItemsGSTValue) : 0,
        fldItemsTotalValue: formData.fldItemsTotalValue ? Number(formData.fldItemsTotalValue) : 0,
        fldDiscountPercentage: formData.fldDiscountPercentage ? Number(formData.fldDiscountPercentage) : 0,
        fldDiscountValue: formData.fldDiscountValue ? Number(formData.fldDiscountValue) : 0,
        fldGrandGrossValue: formData.fldGrandGrossValue ? Number(formData.fldGrandGrossValue) : 0,
        fldOtherPlusValue: formData.fldOtherPlusValue ? Number(formData.fldOtherPlusValue) : 0,
        fldOtherMinusValue: formData.fldOtherMinusValue ? Number(formData.fldOtherMinusValue) : 0,
        fldRoundoff: formData.fldRoundoff ? Number(formData.fldRoundoff) : 0,
        fldGrandTotalValue: formData.fldGrandTotalValue ? Number(formData.fldGrandTotalValue) : 0,
        fldFKPaymentTerms: parseInt(formData.fldFKPaymentTerms)
    });
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.printingDCMasterPATCH}/${id}`,
        responseTypeRequest: UPDATE_ALL_OVER_PRINTING_DC_REQUEST,
        responseTypeSuccess: UPDATE_ALL_OVER_PRINTING_DC_SUCCESS,
        responseTypeFailure: UPDATE_ALL_OVER_PRINTING_DC_FAILURE,
        resetFormData: ALL_OVER_PRINTING_DC_USERFORM_RESET,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchPrintingDC(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

// DELETE PROPERTY MASTER
export let deletePrintingDCMaster = (id, startDate, endDate, unitId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.printingDCMasterDELETE}/${id}`,
        responseTypeRequest: DELETE_ALL_OVER_PRINTING_DC_REQUEST,
        responseTypeSuccess: DELETE_ALL_OVER_PRINTING_DC_SUCCESS,
        responseTypeFailure: DELETE_ALL_OVER_PRINTING_DC_FAILURE,
        modalClose: true,
        getAllData: fetchPrintingDC(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

export let fetchPrintingDCStyleGetList = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.printingDCStyleMasterGET}?ActionCode=PRD`,
        responseTypeRequest: FETCH_ALL_OVER_PRINTING_DC_STYLE_REQUEST,
        responseTypeSuccess: FETCH_ALL_OVER_PRINTING_DC_STYLE_SUCCESS,
        responseTypeFailure: FETCH_ALL_OVER_PRINTING_DC_STYLE_FAILURE
    };
    return axiosCall(config);
};

export let updateCheckAllOverPrinting = (id, reason) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.updateAllCloseIconAllOverPrint}/?FldFKPoNo=${id}&FldReason=${reason?.reason}&IsRollBack=${reason?.checkbox}`,
        responseTypeRequest: CHECK_ALL_UPDATE_REQUEST_ALL_OVER_PRINTING,
        responseTypeSuccess: CHECK_ALL_UPDATE_SUCCESS_COMPACTING_ALL_OVER_PRINTING,
        responseTypeFailure: CHECK_ALL_UPDATE_FALIURE_COMPACTING_ALL_OVER_PRINTING,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return axiosCall(config, true);
};

export let PostCloseIconApiAllOverPrinting = (id, reason) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.postCloseIconALLOVER}?FldId=${id}&FldReason=${reason?.reason}&IsRollBack=${reason?.checkbox}`,
        responseTypeRequest: CLOSE_BTN_POST_REQUEST_ALL_OVER_PRINTING,
        responseTypeSuccess: CLOSE_BTN_POST_SUCCESS_COMPACTING_ALL_OVER_PRINTING,
        responseTypeFailure: CLOSE_BTN_POST_FALIURE_COMPACTING_ALL_OVER_PRINTING,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return axiosCall(config, true);
};
